import "./AccountSettings.scss";

import { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import Button from "../../components/essentials/button/Button";
import ConfirmationModal from "../../components/essentials/modals/confirmation-modal/ConfirmationModal";
import { logoutAction } from "../../core/auth/authSlice";
import AuthApiRoutes from "../../shared/api-routes/auth/auth.api-routes";
import http from "../../shared/utils/http";

function AccountSettings() {
	const dispatch = useDispatch<AppDispatch>();
	const [isDeleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
	const [isDeleting, setIsDeleting] = useState<boolean>(false);

	const handleDeleteAccount = async () => {
		try {
			setIsDeleting(true);
			await http.delete(AuthApiRoutes.DELETE_ACCOUNT);
			dispatch(logoutAction());
			setDeleteModalOpen(false);
		} catch (error) {
			console.error("Failed to delete account:", error);
			alert("Failed to delete account. Please try again.");
		} finally {
			setIsDeleting(false);
		}
	};

	return (
		<>
			<div className="account-settings">
				<div className="account-settings__container">
					<div className="account-settings__header">
						<h1 className="account-settings__title">Account Settings</h1>
						<p className="account-settings__subtitle">
							Manage your account preferences and data
						</p>
					</div>

					<div className="account-settings__section">
						<h2 className="account-settings__section-title">Danger Zone</h2>
						<div className="account-settings__danger-zone">
							<div className="account-settings__danger-item">
								<div className="account-settings__danger-content">
									<h3 className="account-settings__danger-title">
										Delete Account
									</h3>
									<p className="account-settings__danger-description">
										Permanently delete your account and all associated data. This
										action cannot be undone.
									</p>
								</div>
								<Button
									className="btn btn-danger"
									action={() => setDeleteModalOpen(true)}
								>
									Delete Account
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<ConfirmationModal
				title="Are you sure you want to delete your account?"
				state={{
					isModalOpen: isDeleteModalOpen,
					setModalOpen: setDeleteModalOpen,
				}}
				onConfirm={handleDeleteAccount}
			/>
		</>
	);
}

export default AccountSettings;
